import React from "react";
import { motion } from "framer-motion";
import { ShieldCheckIcon } from "lucide-react";
import { Reveal } from "../ui/Reveal";
export function GuaranteeSection() {
  return <section className="bg-blush py-20 lg:py-24" data-id="element-175" data-mp="1kbvrzgl9z0we">
      <div className="mx-auto grid max-w-5xl items-center gap-12 px-5 md:grid-cols-[auto_1fr]" data-id="element-176" data-mp="1kakn1dg3fn3p">
        <Reveal className="mx-auto" data-id="element-177" data-mp="1fbzorjkejdhw">
          <div className="relative h-56 w-56 sm:h-64 sm:w-64" data-id="element-178" data-mp="1faya7546g8vf">
            <motion.svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full" animate={{
            rotate: 360
          }} transition={{
            duration: 30,
            repeat: Infinity,
            ease: "linear"
          }} aria-hidden data-id="element-179" data-mp="1af992xciejx0">
              <defs data-id="element-180" data-mp="weomrr7dy5yr">
                <path id="seal-circle" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" data-id="element-181" data-mp="wfhogdrhm5a1" />
              </defs>
              <circle cx="100" cy="100" r="96" fill="#B98A3E" data-id="element-182" data-mp="2voy8ycradsh3" />
              <circle cx="100" cy="100" r="90" fill="none" stroke="#E8C987" strokeWidth="1.5" strokeDasharray="3 4" data-id="element-183" data-mp="2qszgacyxdoav" />
              <text style={{
              fontFamily: "DM Sans",
              fontWeight: 800,
              fontSize: 13,
              letterSpacing: 3
            }} fill="#FBF6F0" data-id="element-184" data-mp="1g3abl7ta2lmq">
                <textPath href="#seal-circle" data-id="element-185" data-mp="1l1tx573ylvek">GARANTÍA TOTAL · 100% REEMBOLSO · SIN PREGUNTAS ·</textPath>
              </text>
            </motion.svg>
            <div className="absolute inset-[22%] flex flex-col items-center justify-center rounded-full bg-cocoa text-center text-cream shadow-inner" data-id="element-186" data-mp="1c2goggnntauw">
              <ShieldCheckIcon className="h-7 w-7 text-gold-light" data-id="element-187" data-mp="1zv6uyacsn1xs" />
              <span className="font-display text-4xl font-bold leading-none" data-id="element-188" data-mp="23twhasft7ttk">30</span>
              <span className="text-xs font-bold uppercase tracking-widest" data-id="element-189" data-mp="1q1yc2sp7yi2o">días</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.05} data-id="element-190" data-mp="1uzzvjeqk4jeo">
          <h2 className="font-display text-3xl font-bold leading-tight text-cocoa sm:text-4xl" data-id="element-191" data-mp="2irym15ykulce">Garantía de Satisfacción Total de 30 Días</h2>
          <p className="mt-5 text-lg leading-relaxed text-cocoa-light" data-id="element-192" data-mp="2nj6u9yo680nz">
            Prueba el Pack Dulce Saludable durante una semana. Haz al menos 3 recetas diferentes. Come con tus hijos. Si, por cualquier razón, no
            sientes que vale 10 veces más de lo que pagaste — o simplemente no es para ti — nos lo dices y{" "}
            <b className="text-cocoa" data-id="element-193" data-mp="2ni11gl8bubht">recibirás un reembolso del 100% de tu dinero.</b>
          </p>
          <p className="mt-4 text-lg font-semibold text-cocoa" data-id="element-194" data-mp="2ijhcsd2cmllr">Sin explicaciones largas. Sin formularios complicados. Es tan simple como eso.</p>
        </Reveal>
      </div>
    </section>;
}